import { IRootState } from '../../app/store';

export const selectUserAuthenticationStatus = (state: IRootState) =>
    state.login.isUserAuthenticated;
export const selectClientAuthorizedForSkill = (state: IRootState) =>
    state.login.hasSkillAuthorization;
export const selectAuthenticationError = (state: IRootState) =>
    state.login.error;
export const selectAsyncStatus = (state: IRootState) => state.login.asyncStatus;
export const selectCheckLoginAsyncStatus = (state: IRootState) =>
    state.login.checkLoginAsyncStatus;
export const selectFirstName = (state: IRootState) => state.login.firstName;
export const selectLastName = (state: IRootState) => state.login.lastName;
export const selectOriginalRedirectUrl = (state: IRootState) =>
    state.login.originalRedirectUrl;
export const selectClientId = (state: IRootState) => state.login.clientId;
export const selectUserId = (state: IRootState) => state.login.userId;
export const selectUserRole = (state: IRootState) => state.login.userRole;
export const selectIsUserAdmin = (state: IRootState) =>
    state.login.userRole.name?.includes('administrator') ||
    state.login.userRole.name?.includes('coordinator');
export const selectUserPermissions = (state: IRootState) => {
    const permissionDetails =
        (state.login.userRole && state.login.userRole.permissions) || [];
    return permissionDetails.map((permission: any) => permission.name);
};
export const selectClientInfo = (state: IRootState) => state.login.clientInfo;
export const selectEcrId = (state: IRootState) => state.login.ecrId;
export const selectUserEmail = (state: IRootState) => state.login.email;
export const selectClientFeatureFlags = (state: IRootState) =>
    state.login.clientFeatureFlags;
export const selectSkillEvaluator = (state: IRootState) =>
    state.login.userRole?.isSkillEvaluator || false;
